import React from "react";

function LoanSarvSuraksha() {
    return (
        <>
            <div className="container my-5 mx-auto px-2 md:px-5">
                <h2 className="openSans-Reg text-black my-3 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                    Sarv Suraksha Insurance
                </h2>
                <div className="flex flex-wrap w-full">
                    <div className="relative w-full md:w-1/2 mb-2 pb-2 border-b border-gray-300 pr-0 md:pr-2">
                        <p className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                            Personal Accident Cover
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                            (Death / Permanent Total Disability/Permanent
                            Partial Disability)
                        </p>
                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                            <span className="WebRupee">Rs.</span>
                            <span>1,00,000</span>
                        </p>
                    </div>
                    <div className="relative w-full md:w-1/2 mb-2 pb-2 border-b border-gray-300 pl-0 md:pl-2">
                        <p className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                            Accidental Hospitalization
                        </p>
                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                            <span className="WebRupee">Rs.</span>
                            <span>1,00,000</span>
                        </p>
                    </div>
                    <div className="relative w-full md:w-1/2 mb-2 pb-2 border-b border-gray-300 pr-0 md:pr-2">
                        <p className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                            Credit Shield
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track mb-3">
                            (Death / Permanent Total Disability)
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                            Outstanding loan upto
                        </p>
                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                            <span className="WebRupee">Rs.</span>
                            <span>5,00,000</span>
                        </p>
                    </div>
                    <div className="relative w-full md:w-1/2 mb-2 pb-2 border-b border-gray-300 pl-0 md:pl-2">
                        <p className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                            Household Cover
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track mb-3">
                            (Covers various risks and contingencies arising from
                            fire and burglary)
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                            Upto
                        </p>
                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                            <span className="WebRupee">Rs.</span>
                            <span>1,50,000</span>
                        </p>
                    </div>
                    <div className="relative w-full md:w-1/2 mb-2 pb-2 border-b border-gray-300 pr-0 md:pr-2">
                        <p className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                            Critical Illness
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                            (10 Major Illness are covered)
                        </p>
                        <ul className="flex flex-wrap justify-between flex-row lg:flex-row w-full md:w-3/4">
                            <li>
                                <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                                    upto 45 yrs
                                </p>
                                <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                    <span className="WebRupee">Rs.</span>
                                    <span>1,00,000</span>
                                </p>
                            </li>
                            <li>
                                <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                                    for 45 - 50 yrs
                                </p>
                                <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                    <span className="WebRupee">Rs.</span>
                                    <span>75,000</span>
                                </p>
                            </li>
                            <li>
                                <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                                    for 50-60 yrs
                                </p>
                                <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                                    <span className="WebRupee">Rs.</span>
                                    <span>50,000</span>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="relative w-full md:w-1/2 mb-2 pb-2 border-b border-gray-300 pl-0 md:pl-2">
                        <p className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                            Garage Cash
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                            (Motor maintenance cost is covered due to an
                            accident. Benefit can be received from authorised
                            garage)
                        </p>
                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                            <span className="WebRupee">Rs.</span>
                            <span>500</span>
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                            per day allowance upto 7 days, only for 1st year
                        </p>
                    </div>
                    <div className="relative w-full md:w-1/2 mb-2 pr-0 md:pr-2">
                        <p className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                            Loss of Job
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                            (Due to retrenchment from employer in view of Merger
                            and Acquisition)
                        </p>
                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-track">
                            upto
                        </p>
                        <p className="openSans-SemiBold text-track text-lg md:text-2xl xl:text-2xl relative">
                            3 EMI’s
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoanSarvSuraksha;
